import { Dimension } from './types';

export const INITIAL_DIMENSION: Dimension = {
  width: 0,
  height: 0,
  top: 0,
  bottom: 0,
  x: 0,
  y: 0,
};
